/**
 * Custom Color V2 - Short Term Solution
 * Handles custom color selection without SVG manipulation
 */

console.log('[CUSTOM-COLOR-V2] Script loaded');

class CustomColorSelector {
  constructor() {
    console.log('[CUSTOM-COLOR-V2] Constructor called');
    this.init();
  }

  init() {
    console.log('[CUSTOM-COLOR-V2] Init started');
    
    // Check if custom colors are available
    const colorDataElement = document.getElementById('custom-color-data');
    console.log('[CUSTOM-COLOR-V2] Color data element found:', !!colorDataElement);
    
    if (!colorDataElement) {
      console.log('[CUSTOM-COLOR-V2] No custom color data found, exiting');
      return;
    }

    try {
      this.colorData = JSON.parse(colorDataElement.textContent);
      console.log('[CUSTOM-COLOR-V2] Color data parsed:', this.colorData);
      
      this.setupElements();
      this.bindEvents();
      // Re-enable hiding but with better debugging
      console.log('[CUSTOM-COLOR-V2] About to hide Custom Color variant option');
      this.hideCustomColorVariant();
      this.setupMutationObserver();
      this.listenForVariantChanges();
    } catch (error) {
      console.error('[CUSTOM-COLOR-V2] Failed to initialize:', error);
    }
  }

  listenForVariantChanges() {
    // Listen for Shopify variant change events
    document.addEventListener('variant:change', () => {
      console.log('[CUSTOM-COLOR-V2] Variant changed, re-hiding Custom Color if needed');
      setTimeout(() => this.hideCustomColorVariant(), 100);
    });
    
    // Listen for any clicks on color options (more reliable than form change)
    document.addEventListener('click', (e) => {
      const target = e.target;
      // Check if a color radio or its label was clicked
      if (target.type === 'radio' && target.name && target.name.includes('Color')) {
        console.log('[CUSTOM-COLOR-V2] Color radio clicked, will re-hide Custom Color');
        setTimeout(() => this.hideCustomColorVariant(), 150);
      }
      // Also check for clicks on labels
      if (target.closest('label') && target.closest('fieldset')) {
        const input = target.closest('label').querySelector('input[type="radio"]');
        if (input && input.name && input.name.includes('Color')) {
          console.log('[CUSTOM-COLOR-V2] Color label clicked, will re-hide Custom Color');
          setTimeout(() => this.hideCustomColorVariant(), 150);
        }
      }
    }, true); // Use capture phase to catch events early
    
    // Also listen for form changes as backup
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('change', (e) => {
        if (e.target.name && e.target.name.includes('Color')) {
          setTimeout(() => this.hideCustomColorVariant(), 100);
        }
      });
    }
  }

  setupElements() {
    this.popup = document.getElementById('custom-color-popup-v2');
    this.swatchButtons = document.querySelectorAll('.custom-color-swatch');
    this.selectedColorDisplay = document.querySelector('.custom-color-selected');
    this.selectedColorCodeInput = document.getElementById('selected-custom-color-code');
    
    // Popup elements
    if (this.popup) {
      this.popupImage = this.popup.querySelector('.selected-color-image');
      this.popupColorName = this.popup.querySelector('.selected-color-name');
      // Product title and price removed - no longer needed
      this.popupSelectButton = this.popup.querySelector('[data-select-custom-color]');
      this.popupCloseButtons = this.popup.querySelectorAll('[data-close-popup]');
    }

    // Move hidden inputs into the product form if they're not already there
    this.moveInputsToForm();
    
    // Store reference to display input
    this.displayColorInput = document.getElementById('custom-color-display-input');
  }

  moveInputsToForm() {
    // Find the correct product form
    const productFormComponent = document.querySelector('product-form-component');
    let productForm = null;
    
    if (productFormComponent) {
      productForm = productFormComponent.querySelector('form[data-type="add-to-cart-form"]');
    }
    
    if (!productForm) {
      productForm = document.querySelector('form[action*="/cart/add"]');
    }
    
    if (!productForm) {
      console.warn('[CUSTOM-COLOR-V2] Product form not found');
      return;
    }

    console.log('[CUSTOM-COLOR-V2] Found product form:', productForm.id || 'no-id');

    // Move color code input into the form if it's outside
    if (this.selectedColorCodeInput && !productForm.contains(this.selectedColorCodeInput)) {
      console.log('[CUSTOM-COLOR-V2] Moving color code input to form');
      productForm.appendChild(this.selectedColorCodeInput);
    }
    
    // Create the main custom color property input (will display without prefix in cart)
    if (!document.getElementById('custom-color-display-input')) {
      const displayInput = document.createElement('input');
      displayInput.type = 'hidden';
      displayInput.id = 'custom-color-display-input';
      displayInput.name = 'properties[Custom Color]';  // No underscore - we want this visible
      displayInput.value = '';
      productForm.appendChild(displayInput);
      this.displayColorInput = displayInput;
      console.log('[CUSTOM-COLOR-V2] Created display color input for cart');
    }
  }

  bindEvents() {
    // Swatch selection
    this.swatchButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleSwatchClick(e));
    });

    // Popup events
    if (this.popup) {
      // Close popup
      this.popupCloseButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closePopup());
      });

      // Select color button
      if (this.popupSelectButton) {
        this.popupSelectButton.addEventListener('click', () => this.selectColor());
      }

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.popup.classList.contains('active')) {
          this.closePopup();
        }
      });
    }

    // Listen for standard color selection to clear custom color
    this.listenForStandardColorSelection();
  }

  listenForStandardColorSelection() {
    // Watch for changes to color variant options (excluding Custom Color)
    const colorRadios = document.querySelectorAll('input[type="radio"][name*="Color"]');
    colorRadios.forEach(radio => {
      if (radio.value !== 'Custom Color') {
        radio.addEventListener('change', () => {
          if (radio.checked) {
            console.log('[CUSTOM-COLOR-V2] Standard color selected, clearing custom selection');
            this.resetSelection();
          }
        });
      }
    });

    // Also watch dropdowns
    const selectElements = document.querySelectorAll('select');
    selectElements.forEach(select => {
      select.addEventListener('change', () => {
        if (select.value !== 'Custom Color' && select.value !== '') {
          // Check if this is a color-related select
          const hasColorOption = Array.from(select.options).some(opt => 
            opt.value === 'Custom Color' || opt.text.includes('Color')
          );
          if (hasColorOption) {
            console.log('[CUSTOM-COLOR-V2] Standard color selected from dropdown, clearing custom selection');
            this.resetSelection();
          }
        }
      });
    });
  }

  hideCustomColorVariant() {
    console.log('[CUSTOM-COLOR-V2] hideCustomColorVariant called - starting to look for Custom Color options');
    
    // Find and hide the "Custom Color" option in the variant picker
    const allRadioInputs = document.querySelectorAll('input[type="radio"]');
    console.log('[CUSTOM-COLOR-V2] Total radio inputs found:', allRadioInputs.length);
    
    // Debug: Log all radio values
    allRadioInputs.forEach((input, index) => {
      console.log(`[CUSTOM-COLOR-V2] Radio ${index}: name="${input.name}", value="${input.value}"`);
    });
    
    const variantInputs = document.querySelectorAll('input[type="radio"][value="Custom Color"]');
    console.log('[CUSTOM-COLOR-V2] Found variant inputs with value="Custom Color":', variantInputs.length);
    
    variantInputs.forEach((input, index) => {
      const label = input.closest('label');
      if (label) {
        console.log(`[CUSTOM-COLOR-V2] Hiding label ${index} for Custom Color option`);
        // Use display: none but add a data attribute to track it
        label.style.display = 'none';
        label.setAttribute('data-custom-color-hidden', 'true');
        label.setAttribute('data-custom-color-debug', 'hidden-by-custom-color-v2');
        
        console.log(`[CUSTOM-COLOR-V2] Label ${index} hidden. Parent element:`, label.parentElement);
      } else {
        console.log(`[CUSTOM-COLOR-V2] No label found for input ${index}`);
      }
    });

    // Also hide from dropdowns
    const allSelectOptions = document.querySelectorAll('select option');
    console.log('[CUSTOM-COLOR-V2] Total select options found:', allSelectOptions.length);
    
    allSelectOptions.forEach((option, index) => {
      if (option.value === 'Custom Color' || option.textContent === 'Custom Color') {
        console.log(`[CUSTOM-COLOR-V2] Found Custom Color in dropdown at index ${index}: value="${option.value}", text="${option.textContent}"`);
        option.style.display = 'none';
        option.setAttribute('data-custom-color-hidden', 'true');
      }
    });
  }

  // Watch for DOM changes and re-hide Custom Color if it reappears
  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldHide = false;
      
      mutations.forEach((mutation) => {
        // Check for any DOM changes that might have revealed Custom Color
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          // Look for Custom Color radio that isn't hidden
          const customColorRadio = document.querySelector('input[type="radio"][value="Custom Color"]');
          if (customColorRadio) {
            const label = customColorRadio.closest('label');
            if (label && label.style.display !== 'none') {
              shouldHide = true;
            }
          }
        }
      });
      
      if (shouldHide) {
        console.log('[CUSTOM-COLOR-V2] MutationObserver detected Custom Color became visible, re-hiding');
        this.hideCustomColorVariant();
      }
    });

    // Observe multiple containers that might change
    const containers = document.querySelectorAll('variant-picker, .variant-picker, .variant-option, fieldset.variant-option');
    containers.forEach(container => {
      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      });
    });
    
    if (containers.length > 0) {
      console.log(`[CUSTOM-COLOR-V2] MutationObserver set up on ${containers.length} containers`);
    }
  }

  handleSwatchClick(event) {
    const button = event.currentTarget;
    const swatchIndex = parseInt(button.dataset.swatchIndex);
    const swatchData = this.colorData.swatches[swatchIndex];
    
    if (!swatchData) return;

    // Store the button that was clicked for later reference
    this.currentSwatchButton = button;
    
    // Store selection temporarily (not confirmed yet)
    this.tempSelectedSwatch = swatchData;

    // Open popup for confirmation
    this.openPopup(swatchData);
  }

  openPopup(swatchData) {
    if (!this.popup) return;

    // Update popup content - use medium size image for faster loading
    if (this.popupImage) {
      // Use imageMedium (600x600) for popup, fallback to image if not available
      this.popupImage.src = swatchData.imageMedium || swatchData.image || swatchData.imageLarge;
      this.popupImage.alt = swatchData.name;
    }
    
    // Update color name (now shown below image)
    if (this.popupColorName) {
      this.popupColorName.textContent = swatchData.name;
    }

    // Product title and price removed - no longer needed

    // Show popup
    this.popup.classList.add('active');
    this.popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    if (!this.popup) return;
    
    this.popup.classList.remove('active');
    this.popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  selectColor() {
    if (!this.tempSelectedSwatch || !this.currentSwatchButton) return;

    // Update selection state
    this.swatchButtons.forEach(btn => btn.classList.remove('selected'));
    this.currentSwatchButton.classList.add('selected');

    // Update display
    if (this.selectedColorDisplay) {
      this.selectedColorDisplay.textContent = `- ${this.tempSelectedSwatch.name}`;
    }

    // Store confirmed selection
    this.selectedSwatch = this.tempSelectedSwatch;
    
    // Update hidden inputs for form submission
    if (this.selectedColorCodeInput) {
      this.selectedColorCodeInput.value = this.tempSelectedSwatch.code;
    }
    
    // Update the display input that will show in cart (just the color name)
    if (this.displayColorInput) {
      this.displayColorInput.value = this.tempSelectedSwatch.name;
      console.log('[CUSTOM-COLOR-V2] Updated display color for cart:', this.tempSelectedSwatch.name);
    } else {
      // Try to find it if it wasn't stored
      const displayInput = document.getElementById('custom-color-display-input');
      if (displayInput) {
        displayInput.value = this.tempSelectedSwatch.name;
        this.displayColorInput = displayInput;
      }
    }

    // IMPORTANT: Automatically select the "Custom Color" variant option
    this.selectCustomColorVariant();
    
    // Get the Custom Color variant ID and trigger inventory update
    const customColorVariantId = window.customColorVariantId || document.getElementById('custom-color-variant-id')?.value;
    if (customColorVariantId) {
      this.triggerVariantUpdate(customColorVariantId);
    }

    // Close popup
    this.closePopup();
    
    // Trigger custom event to notify that a color was selected
    document.dispatchEvent(new CustomEvent('customColorSelected', {
      detail: {
        name: this.tempSelectedSwatch.name,
        code: this.tempSelectedSwatch.code,
        image: this.tempSelectedSwatch.image
      }
    }));
  }

  triggerVariantUpdate(variantId) {
    console.log('[CUSTOM-COLOR-V2] Triggering variant update for inventory section, variant ID:', variantId);
    
    // Get the current section element
    const section = this.popup?.closest('.shopify-section') || document.querySelector('.shopify-section');
    
    if (section && variantId) {
      // We need to fetch the variant data to properly update the inventory
      fetch(`${window.location.pathname}?variant=${variantId}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(html, 'text/html');
          
          // Find the inventory element in the new HTML
          const newInventory = newDocument.querySelector('product-inventory');
          const currentInventory = document.querySelector('product-inventory');
          
          if (newInventory && currentInventory) {
            // Update the inventory display directly
            const newStatusElement = newInventory.querySelector('.product-inventory__text');
            const currentStatusElement = currentInventory.querySelector('.product-inventory__text');
            
            if (newStatusElement && currentStatusElement) {
              currentStatusElement.innerHTML = newStatusElement.innerHTML;
              console.log('[CUSTOM-COLOR-V2] Inventory status updated');
            }
            
            // Update the icon status class
            const newIcon = newInventory.querySelector('.product-inventory__icon');
            const currentIcon = currentInventory.querySelector('.product-inventory__icon');
            
            if (newIcon && currentIcon) {
              currentIcon.className = newIcon.className;
            }
          }
          
          // Also dispatch the standard variant update event for other components
          const variantUpdateEvent = new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant: { id: variantId } }
          });
          document.dispatchEvent(variantUpdateEvent);
        })
        .catch(error => {
          console.error('[CUSTOM-COLOR-V2] Failed to fetch variant data:', error);
        });
    }
  }

  selectCustomColorVariant() {
    console.log('[CUSTOM-COLOR-V2] Selecting Custom Color variant');
    
    // Debug: Log all radio inputs to see what's available
    const allRadios = document.querySelectorAll('input[type="radio"]');
    console.log('[CUSTOM-COLOR-V2] All radio inputs on page:', allRadios.length);
    allRadios.forEach((radio, i) => {
      if (radio.name.includes('Color')) {
        console.log(`[CUSTOM-COLOR-V2] Color radio ${i}: value="${radio.value}", checked=${radio.checked}, visible=${radio.offsetParent !== null}`);
      }
    });
    
    // IMPORTANT: First deselect all other color options
    const allColorRadios = document.querySelectorAll('input[type="radio"][name*="Color"]');
    allColorRadios.forEach(radio => {
      if (radio.value !== 'Custom Color') {
        radio.checked = false;
        console.log(`[CUSTOM-COLOR-V2] Deselected color: ${radio.value}`);
      }
    });
    
    // Now find and click the "Custom Color" option in the regular color picker
    // This will make the UI show Custom Color as selected
    const customColorRadio = document.querySelector('input[type="radio"][value="Custom Color"]');
    if (customColorRadio) {
      console.log('[CUSTOM-COLOR-V2] Found Custom Color radio, selecting it');
      console.log('[CUSTOM-COLOR-V2] Custom Color radio current state: checked=' + customColorRadio.checked);
      console.log('[CUSTOM-COLOR-V2] Custom Color radio parent:', customColorRadio.parentElement);
      
      // First unhide it temporarily if it was hidden
      const customColorLabel = customColorRadio.closest('label');
      if (customColorLabel) {
        const wasHidden = customColorLabel.style.display === 'none';
        if (wasHidden) {
          console.log('[CUSTOM-COLOR-V2] Custom Color label was hidden, temporarily showing it');
          customColorLabel.style.display = '';
        }
        
        // Now select it - set checked BEFORE clicking for consistency
        customColorRadio.checked = true;
        
        // Trigger a click on the label to ensure all event handlers fire
        customColorLabel.click();
        console.log('[CUSTOM-COLOR-V2] Clicked Custom Color label for visual update');
        
        // Also dispatch a change event to ensure variant update
        const changeEvent = new Event('change', { bubbles: true, cancelable: true });
        customColorRadio.dispatchEvent(changeEvent);
        
        // Hide it again after selection if needed
        if (wasHidden) {
          setTimeout(() => {
            customColorLabel.style.display = 'none';
            console.log('[CUSTOM-COLOR-V2] Re-hidden Custom Color label after selection');
          }, 100);
        }
      } else {
        console.log('[CUSTOM-COLOR-V2] No label found, dispatching change event');
        customColorRadio.checked = true;
        const changeEvent = new Event('change', { bubbles: true, cancelable: true });
        customColorRadio.dispatchEvent(changeEvent);
      }
    } else {
      console.log('[CUSTOM-COLOR-V2] WARNING: Custom Color radio not found!');
    }
    
    // Get the Custom Color variant ID from the hidden input
    const customColorVariantInput = document.getElementById('custom-color-variant-id');
    if (customColorVariantInput) {
      const variantId = customColorVariantInput.value;
      console.log('[CUSTOM-COLOR-V2] Found Custom Color variant ID:', variantId);
      
      // Find ALL variant ID inputs and update them
      const variantIdInputs = document.querySelectorAll('input[name="id"]');
      console.log('[CUSTOM-COLOR-V2] Found variant ID inputs:', variantIdInputs.length);
      
      variantIdInputs.forEach((variantIdInput, index) => {
        console.log(`[CUSTOM-COLOR-V2] Updating variant ID input ${index} from ${variantIdInput.value} to ${variantId}`);
        variantIdInput.value = variantId;
        
        // Add a data attribute to track that this was set by custom color
        variantIdInput.setAttribute('data-custom-color-variant', variantId);
      });
      
      // Store the custom color variant ID globally for later reference
      window.customColorVariantId = variantId;
      
      // Also try to update the product-form-component's data
      const productFormComponents = document.querySelectorAll('product-form-component');
      productFormComponents.forEach(productForm => {
        if (productForm.refs && productForm.refs.variantId) {
          console.log('[CUSTOM-COLOR-V2] Updating product-form-component variant ID');
          productForm.refs.variantId.value = variantId;
        }
      });
      
      console.log('[CUSTOM-COLOR-V2] Custom Color variant selected via ID update');
    } else {
      console.warn('[CUSTOM-COLOR-V2] Custom Color variant ID not found in hidden input');
    }
  }

  resetSelection() {
    // Clear all selections
    this.swatchButtons.forEach(btn => btn.classList.remove('selected'));
    this.selectedSwatch = null;
    this.tempSelectedSwatch = null;
    this.currentSwatchButton = null;
    
    // Clear display
    if (this.selectedColorDisplay) {
      this.selectedColorDisplay.textContent = '';
    }
    
    // Clear hidden inputs
    if (this.selectedColorCodeInput) {
      this.selectedColorCodeInput.value = '';
    }
    
    // Clear the display input for cart
    if (this.displayColorInput) {
      this.displayColorInput.value = '';
    } else {
      const displayInput = document.getElementById('custom-color-display-input');
      if (displayInput) {
        displayInput.value = '';
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.customColorSelector = new CustomColorSelector();
  });
} else {
  window.customColorSelector = new CustomColorSelector();
}

// Add animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideInUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  @keyframes slideOutDown {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(100%);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);

